import React, { useEffect, useState } from "react";
import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import {Link } from 'react-router-dom';
import "./Profile.css";
import api from "../../utils/api";
import ExperienceAndEducation from "./ExperienceAndEducation";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import WorkIcon from "@mui/icons-material/Work";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import HomeIcon from "@mui/icons-material/Home";

export const Profile = ({ setShowInterestCollectionGrid }) => {
  const [userData, setUserData] = useState({});
  const [showUploadProfile, setShowUploadProfile] = useState(false);
  const [files, setFiles] = useState();
  const [profileImage, setProfileImage] = useState("");
  let navigate = useNavigate();
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const params = useParams();
  const [totalPosts, setTotalPosts] = useState(0);
  useEffect(() => {
    api
      .get(
        `/questions/get-my-questions/${
          params?.userId ? params?.userId : currentUser?.id
        }`
      )
      .then((res) => setTotalPosts(res.data.length))
      .catch((err) => console.log(err));
  }, []);
  const [categoriesOfInterest, setCategoriesOfInterest] = useState([]);
  useEffect(() => {
    setCategoriesOfInterest(currentUser?.categoriesInterested);
  }, [currentUser]);
  // useEffect(() => {
  //   console.log("current user>>>", currentUser);
  //   if (currentUser?.profile) {
  //     setProfileImage(currentUser.profile);
  //   }
  // }, [currentUser]);
  console.log("profile image", profileImage);
  useEffect(() => {
    api
      .get(
        `/auth/get-user-data/${
          params?.userId ? params?.userId : currentUser?.id
        }`
      )
      .then((res) => {
        if (res.data) {
          setUserData(res.data);
          console.log("user data>", res.data);
          setProfileImage(res.data?.profile);
        }
      })
      .catch((err) => console.log(err));
  }, [params?.userId]);
  const uploadPhoto = async (e) => {
    console.log(e.target);
    console.log("running upload file ");
    let files = e.target.files;
    if (files?.length > 0) {
      const data = new FormData();
      data.append("file", files[0]);
      data.append("upload_preset", "bpyoqbty");

      const res = await fetch(
        "https://api.cloudinary.com/v1_1/dqmbkvawu/image/upload",

        {
          method: "POST",
          body: data,
        }
      );
      const file = await res.json();
      console.log("response from cloudinary>>>", file);
      setProfileImage(file?.secure_url);
      let e2 = { target: { name: "image", value: file.secure_url } };
      // handleChange(e2);
      console.log("file profie image>>> ", file);
    }
  };
  const saveProfile = (e) => {
    e.preventDefault();
    console.log("running ");
    if (profileImage !== "") {
      api
        .put("/user/updateProfileImage", {
          userId: currentUser?.id,
          imgUrl: profileImage,
        })
        .then((res) => {
          console.log("res from uload profile", res.data);
          var currentObject = Object.assign(currentUser, {
            profile: profileImage,
          });
          console.log("profile ", currentObject);
          localStorage.setItem("currentUser", JSON.stringify(currentObject));
          setShowUploadProfile(false);
          window.location.reload();
        })
        .catch((err) => console.log("error from uploading profile", err));
    }
  };
  return (
    <Box>
      {/* <Header />
      <Menunav /> */}
      <Box className="row">
        {/* <Box className="col-md-2 col-0">
        <Sidebar /> 
        </Box> */}
        <Box className="col-md-12 col-12 mb-1">
          <section
            className="row my-4"
            sx={{ backgroundColor: "colorWhiteSmoke.main" }}
          >
            <Box className="col-lg-3 col-md-4 col-12">
              <a href={profileImage} target="_blank">
                <img
                  className="profile-image"
                  src={
                    profileImage
                      ? profileImage
                      : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460__340.png"
                  }
                  alt="image"
                />
              </a>
              {!params?.userId && (
                <Box
                  className="photo__updation__form"
                  sx={{ paddingLeft: "80px" }}
                >
                  <Typography
                    for="select-profile"
                    onClick={(e) => setShowUploadProfile(!showUploadProfile)}
                    variant="body"
                    sx={{
                      width: "max-content",
                      color: "fontPrimaryColor.main",
                      marginLeft: "15px",
                    }}
                  >
                    Change Profile
                  </Typography>
                  {showUploadProfile && (
                    <Box>
                      <input
                        type="file"
                        name="select-profile"
                        id="updateProfileImageInput"
                        onChange={(e) => uploadPhoto(e)}
                        className="input__field__asc"
                        //value={user.picture}
                      />
                      <button
                        className="updateInfoBtn  asc__submit__form__button"
                        onClick={(e) => saveProfile(e)}
                      >
                        upload
                      </button>
                    </Box>
                  )}
                </Box>
              )}
            </Box>
            <Box className="col-lg-8 col-md-7 col-12">
              <Typography
                variant="h4"
                className="mt-4"
                sx={{
                  color: "fontPrimaryColor.main",
                  textTransform: "caitalize",
                }}
              >
                {" "}
                {userData?.name}{" "}
              </Typography>
              <Typography
                variant="p"
                className="mt-0"
                sx={{ color: "fontPrimaryColor.main" }}
              >
                {" "}
                {userData?.email}{" "}
              </Typography>
              <Typography
                variant="p"
                className="mt-0"
                sx={{
                  color: "fontPrimaryColor.main",
                  display: "block",
                  textTransform: "capitalize",
                }}
              >
                {" "}
                {userData?.userRole ? userData?.userRole : "not mentioned"}{" "}
              </Typography>
            </Box>
          </section>
          {/* <hr /> */}
          <Box sx={{ padding: " 10px 20px" }}>
            <Typography
              className="my-0"
              variant="h5"
              sx={{ fontWeight: "600" }}
            >
              About Info
            </Typography>
            <Box
              sx={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "space-between",
                gap: "30px",
              }}
              color="fontPrimaryColor.main"
            >
              {userData?.university ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  {" "}
                  <WorkIcon />
                  <Typography
                    variant="p"
                    sx={{ fontSize: "1.1rem" }}
                    color="fontPrimaryColor.main"
                  >
                    {" "}
                    {userData?.university == "university"
                      ? "Studying at University"
                      : "Working at Company"}
                  </Typography>
                </Box>
              ) : (
                <></>
              )}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                  flexDirection: "column",
                }}
                color="fontPrimaryColor.main"
              >
                {" "}
                <PersonIcon />
                <Typography
                  variant="p"
                  sx={{ fontSize: "1.1rem" }}
                  color="fontPrimaryColor.main"
                >
                  {" "}
                  {userData?.gender ? userData?.gender : "not mentioned"}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
                color="fontPrimaryColor.main"
              >
                {" "}
                <LocalPhoneIcon />
                <Typography
                  variant="p"
                  sx={{ fontSize: "1.1rem" }}
                  color="fontPrimaryColor.main"
                >
                  {" "}
                  {userData?.phone ? userData?.phone : "not mentioned"}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  flexDirection: "column",
                  justifyContent: "center",
                  maxWidth: "40%",
                }}
                color="fontPrimaryColor.main"
              >
                {" "}
                <HomeIcon />
                <Typography
                  variant="p"
                  sx={{ fontSize: "1.1rem" }}
                  color="fontPrimaryColor.main"
                >
                  {" "}
                  {userData?.address ? userData?.address : "not mentioned"}
                </Typography>
              </Box>
            </Box>
            {/********************* */}

            <Box>
              <Typography
                variant="h6"
                sx={{ fontSize: "1.1rem", marginTop: "20px" }}
                color="fontPrimaryColor.main"
              >
                {userData?.userRole == "student" ||
                userData?.userRole == "alumni"
                  ? "Student Card"
                  : userData?.userRole == "hostelowner"
                  ? "CNIC"
                  : userData?.userRole == "fypsupervisor"
                  ? "Faculty Card"
                  : userData?.userRole == "sscofficer"
                  ? "Staff Card"
                  : "Employee Card"}
              </Typography>
              {console.log("current user", userData)}
              {userData?.userIdentityFile && (
                <a href={userData?.userIdentityFile} targte="_blank">
                  <img
                    src={userData?.userIdentityFile}
                    style={{
                      height: "150px",
                      width: "auto",
                      marginTop: "20px",
                    }}
                  />
                </a>
              )}
            </Box>
          </Box>
          <Box>
            {!params?.userId && (
              <Box
                className="asc__submit__form__button"
                sx={{ marginLeft: "20px" }}
                onClick={() => navigate("/edit-about")}
              >
                Update about
              </Box>
            )}
            <Box></Box>
            {!params?.userId && (
              <>
                {(currentUser?.userRole == "student" ||
                  currentUser?.userRole == "alumni") && (
                  <>
                    <Box sx={{ padding: " 10px 20px", marginTop: "20px" }}>
                      <Typography
                        className="my-0"
                        variant="h5"
                        sx={{ fontWeight: "600" }}
                      >
                        Interests
                      </Typography>
                      <Box
                        sx={{
                          marginTop: "20px",
                          gap: "30px",
                        }}
                        color="fontPrimaryColor.main"
                      >
                        {categoriesOfInterest?.length > 0 ? (
                          categoriesOfInterest?.map((c) => (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "20px",
                              }}
                            >
                              {" "}
                              <Typography
                                variant="p"
                                sx={{ fontSize: "1.1rem" }}
                                color="fontPrimaryColor.main"
                              >
                                {c}
                              </Typography>
                            </Box>
                          ))
                        ) : (
                          <>N/A</>
                        )}
                        <Box
                          className="asc__submit__form__button"
                          onClick={() => setShowInterestCollectionGrid(true)}
                        >
                          Update Interests
                        </Box>
                      </Box>
                    </Box>
                  </>
                )}
              </>
            )}

            <hr />
            <ExperienceAndEducation
              currentUser={currentUser}
              userData={userData}
              api={api}
            />
            <hr />
            {!params?.userId && (
              <Box className="row">
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "600" }}
                  // className="text-center"
                >
                  Your Posts
                </Typography>
                {/* <h1 className="text-center">{totalPosts}</h1> */}
                <Box
                  sx={{ display: "flex", flexDirection: "row", gap: "10px" }}
                >
                  {(currentUser?.userRole?.toLocaleLowerCase() == "student" ||
                    currentUser?.userRole?.toLocaleLowerCase() == "alumni") && (
                    <button
                      className="asc__submit__form__button mt-3 "
                      style={{ width: "130px" }}
                      onClick={() => navigate("/my-questions")}
                    >
                      Questions
                    </button>
                  )}
                  {(currentUser?.userRole?.toLocaleLowerCase() == "student" ||
                    currentUser?.userRole?.toLocaleLowerCase() == "alumni") && (
                    <button
                      className="asc__submit__form__button mt-3 "
                      style={{ width: "130px" }}
                      onClick={() => navigate("/my-projects")}
                    >
                      Projects
                    </button>
                  )}

                  {currentUser?.userRole?.toLocaleLowerCase() ==
                    "hostelowner" && (
                    <button
                      className="asc__submit__form__button mt-3 "
                      style={{ width: "130px" }}
                      onClick={() => navigate("/my-hostels")}
                    >
                      Hostels
                    </button>
                  )}
                  {(currentUser?.userRole?.toLocaleLowerCase() ==
                    "companyrepresentative" ||
                    currentUser?.userRole?.toLocaleLowerCase() == "alumni") && (
                    <button
                      className="asc__submit__form__button mt-3 "
                      style={{ width: "130px" }}
                      onClick={() => navigate("/my-internships")}
                    >
                      Internships
                    </button>
                  )}
                  {currentUser?.userRole?.toLocaleLowerCase() ==
                    "sscofficer" && (
                    <button
                      className=" asc__submit__form__button mt-3 "
                      style={{ width: "130px" }}
                      onClick={() => navigate("/my-scholarships")}
                    >
                      Scholarships
                    </button>
                  )}
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
